// Catálogo `signature-fonts-v1` (form §7.2). Chaves são imutáveis: troca de
// arquivo tipográfico ou inclusão/remoção de opção exige nova versão do
// catálogo (`signature-fonts-v2`).
//
// Famílias = mesmas do protótipo (Google Fonts script), carregadas em
// `inspection-ui.css`.

export interface InspectionSignatureFont {
  key: string;
  labelKey: string;
  /** Pilha tipográfica usada no preview ao vivo e no PDF (fatia 2). */
  fontFamily: string;
}

export const INSPECTION_SIGNATURE_FONTS: InspectionSignatureFont[] = [
  {
    key: "script-classic",
    labelKey: "inspection.signature.fonts.classic",
    fontFamily: '"Dancing Script", cursive',
  },
  {
    key: "script-elegant",
    labelKey: "inspection.signature.fonts.elegant",
    fontFamily: '"Great Vibes", cursive',
  },
  {
    key: "script-casual",
    labelKey: "inspection.signature.fonts.casual",
    fontFamily: '"Pacifico", cursive',
  },
  {
    key: "script-bold",
    labelKey: "inspection.signature.fonts.bold",
    fontFamily: '"Yellowtail", cursive',
  },
  {
    key: "script-modern",
    labelKey: "inspection.signature.fonts.modern",
    fontFamily: '"Sacramento", cursive',
  },
  {
    key: "script-rounded",
    labelKey: "inspection.signature.fonts.rounded",
    fontFamily: '"Satisfy", cursive',
  },
];

export const DEFAULT_INSPECTION_SIGNATURE_FONT_KEY = "script-classic";

export const signatureFontFamily = (fontKey: string | null) =>
  INSPECTION_SIGNATURE_FONTS.find((font) => font.key === fontKey)?.fontFamily ??
  INSPECTION_SIGNATURE_FONTS[0]!.fontFamily;
